module.exports = __webpack_public_path__ + "img/codigo-qr.fe049de4.png";